export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '5eeb5d58-e66a-406e-b455-02369e1f51c0';
export const MODAL_CLOSE_SEC = 2.5;
